import { useEffect, useRef, useState } from 'react';
import { Badge, Button, Offcanvas } from 'react-bootstrap';

//
import { AiOutlineAlignCenter, AiOutlineAlignLeft, AiOutlineAlignRight } from 'react-icons/ai';
import { fetchWrapper } from '../../../../../../../_helpers/fetchWrapper';

function TextOffCanvas({
  show,
  handleClose,
  handleSave,
  showDynamicValueOptions,
  title,
  initialValue
}) {
  const TextAreaRef = useRef();

  const [offCanvasState, setOffCanvasState] = useState(initialValue);
  const [alignment, setAlignment] = useState(initialValue.alignment);
  const [labels, setLabels] = useState([]);

  useEffect(() => {
    if (showDynamicValueOptions) {
      (async () => {
        const response = await fetchWrapper.get('/certificate/labels');
        setLabels(response.data);
      })();
    }
  }, [showDynamicValueOptions]);

  const handleReset = () => {
    handleSave({ file: null });
  };

  return (
    <Offcanvas show={show} onHide={handleClose} placement={'end'}>
      <Offcanvas.Header closeButton className="border-bottom">
        <Offcanvas.Title>{title}</Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body>
        <div className="mb-3">
          <label className="d-block mb-2" style={{ fontSize: '24px' }} htmlFor="title">
            Text
          </label>
          {showDynamicValueOptions && (
            <div className="mb-3 d-flex flex-wrap">
              <span className="d-block mb-2">
                Dynamice labels:<small>(Click levels to add in content)</small>
              </span>
              {labels.map((dynamicValue) => (
                <Badge
                  className="me-2 p-2 px-3 mb-2 cursor-pointer badge-info"
                  key={dynamicValue.id}
                  onClick={() => {
                    TextAreaRef.current.value += ` [[${dynamicValue.title}]] `;

                    let tempTextValue = TextAreaRef.current.value + ` [[${dynamicValue.title}]] `;
                    setOffCanvasState({
                      ...offCanvasState,
                      text: tempTextValue
                    });
                    TextAreaRef.current.focus();
                  }}>
                  {dynamicValue.title}
                </Badge>
              ))}
            </div>
          )}
          <textarea
            ref={TextAreaRef}
            id="title"
            placeholder="Type here..."
            defaultValue={initialValue.text}
            style={{
              width: '100%',
              height: '100%'
            }}
            rows={8}
            onChange={(e) => setOffCanvasState({ ...offCanvasState, text: e.target.value })}
          />
        </div>

        <div className="mb-3">
          <label className="d-block" style={{ fontSize: '24px' }} htmlFor="title">
            Font size
          </label>
          <input
            type="number"
            defaultValue={initialValue.fontSize}
            onChange={(e) =>
              setOffCanvasState({
                ...offCanvasState,
                fontSize: e.target.value
              })
            }
          />
        </div>

        <div className="mb-3">
          <label className="d-block" style={{ fontSize: '24px' }} htmlFor="title">
            Allignment:
          </label>

          <label>
            <input
              hidden
              type="radio"
              value="left"
              checked={alignment === 'left'}
              onChange={(e) => {
                setOffCanvasState({
                  ...offCanvasState,
                  alignment: e.target.value
                });
                setAlignment(e.target.value);
              }}
            />
            <span
              className={`me-2 p-2 d-flex justify-content-center align-items-center border rounded cursor-pointer ${
                alignment === 'left' ? 'alignment-active' : ''
              }`}>
              <AiOutlineAlignLeft fontSize={32} />
            </span>
          </label>
          <label>
            <input
              hidden
              type="radio"
              value="center"
              checked={alignment === 'center'}
              onChange={(e) => {
                setOffCanvasState({
                  ...offCanvasState,
                  alignment: e.target.value
                });
                setAlignment(e.target.value);
              }}
            />
            <span
              className={`me-2 p-2 d-flex justify-content-center align-items-center border rounded cursor-pointer ${
                alignment === 'center' ? 'alignment-active' : ''
              }`}>
              <AiOutlineAlignCenter fontSize={32} />
            </span>
          </label>
          <label>
            <input
              hidden
              type="radio"
              value="right"
              checked={alignment === 'right'}
              onChange={(e) => {
                setOffCanvasState({
                  ...offCanvasState,
                  alignment: e.target.value
                });
                setAlignment(e.target.value);
              }}
            />
            <span
              className={`me-2 p-2 d-flex justify-content-center align-items-center border rounded cursor-pointer ${
                alignment === 'right' ? 'alignment-active' : ''
              }`}>
              <AiOutlineAlignRight fontSize={32} />
            </span>
          </label>
        </div>

        <div className="mb-3">
          <label className="d-block" style={{ fontSize: '24px' }} htmlFor="title">
            Color:
          </label>
          <input
            type="color"
            defaultValue={initialValue.color}
            onChange={(e) =>
              setOffCanvasState({
                ...offCanvasState,
                color: e.target.value
              })
            }
          />
        </div>

        <Button
          className="mt-3 w-100"
          onClick={() => {
            if (handleSave) handleSave(offCanvasState);
          }}>
          Save
        </Button>

        <div className="border-top mt-3 pt-4">
          <button className="btn btn-outline-danger" onClick={handleReset}>
            Reset
          </button>
        </div>
      </Offcanvas.Body>
    </Offcanvas>
  );
}

export default TextOffCanvas;
